import theme from '@/style';
import {ProgressiveLoadingOverlay} from '@fe-progressive/package-progressive/progressive-loading';
import React from 'react';
import {StyleProp, StyleSheet, View, ViewStyle} from 'react-native';

const Spin = ({
  loading,
  children,
  style,
  overlayStyle,
}: {
  loading: boolean;
  children?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  overlayStyle?: StyleProp<ViewStyle>;
}) => {
  const flattenedOverlayStyle = StyleSheet.flatten(overlayStyle);

  return (
    <View style={[theme.position.rel, style]}>
      {children}
      <ProgressiveLoadingOverlay
        visible={loading}
        style={
          {
            ...flattenedOverlayStyle,
            '--progressive-loading-overlay-background': '#0002',
            '--progressive-loading-overlay-blur': '0px',
          } as React.CSSProperties
        }
      />
    </View>
  );
};

export default Spin;
